/*
 * Service that provides functionality that is meant only for
 * for transitional purposes and will be removed at a later point in time.
 * 
 * e.g.: Provides some hardcoded strings until a planned Rest-Interface is in place to deliver similar data. 
 * 
 * This file must be reviewed regularly and functions must be removed after the real functionality is
 * in place.
 */
(function() {
  angular
    .module('cfn')
    .provider('transition-helper.provider', Transitionhelper);

  //workaround to be able to use the service at bootstrap time.
  app.transitionhelper = new Transitionhelper();

  function Transitionhelper() {
    'use strict';

    this.$get = function() {
      return this;
    };

    this.initGeaLegacyModule = function() {
      // This is a temporary replacement for the legacy mechanisms of loading gea-modules.json via Ajax to define the legacy
      // gea module. Sooner or later the module registered as "gea" (the one with the base loading path
      // "/365FarmNet/mod/dairynet.base/" will be removed completely, all its content will be migrated to other bundles.
      // Then the initGeaLegacyModule function can be removed.
      var geaLegacyModuleData = {
        gea: {
          iconPath: '/365FarmNet/mod/dairynet.base/icons/',
          popupPath: '/365FarmNet/mod/dairynet.base/main/popups/',
          corePath: '/365FarmNet/mod/dairynet.base/main/',
          coreGenPath: '/365FarmNet/mod/dairynet.base/gen/',
          jsPath: '/365FarmNet/mod/dairynet.base/main/',
          jsGenPath: '/365FarmNet/mod/dairynet.base/gen/',
          loadPath: '/dairynet.base/main.html',
          apps: {} // modules.js#initModules produces an error if the app property isn't present
        }
      };
      modules.initModules(function() {}, geaLegacyModuleData);
    };

    this.updateJqueryValidateI18n = function() {
      $.validationEngineLanguage.allRules.required.alertText = i18n(
        'fe.common.pleaseChoose'
      );
    };
  }
})();

angular.module('cfn').run([
  'transition-helper.provider',
  function(transitionhelper) {
    transitionhelper.updateJqueryValidateI18n();
  }
]);

app.hasModule = function(productKey) {
  // Depcreated, we can use ShopService.isProductLicensed(productKey) instead;
  console.warn(
    'Method app.hasModule is deprecated. Use ShopService.isProductLicensed(productKey) instead.'
  );

  if (!app.credentials.licensedProducts)
    // Login
    return false;

  return app.credentials.licensedProducts.indexOf(productKey) != -1;
};
